var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_186_14286",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 56,
    height: 56,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_186_14286)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_186_14286",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 53,
    height: 54
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.25,
    y: 1.75,
    width: 52.5,
    height: 52.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_186_14286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 10.5595V18.5291L28.4998 22.5951L4 18.5291V10.5595C4 7.9524 6.0983 5.83954 8.68747 5.83954H48.3125C50.9017 5.83954 53 7.9524 53 10.5595Z",
    fill: "#F8485E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14725 18.5291V10.5595C7.14725 7.9524 9.24555 5.83954 11.8347 5.83954H8.68747C6.0983 5.83954 4 7.9524 4 10.5595V18.5291L28.4998 22.5951L30.0734 22.3339L7.14725 18.5291Z",
    fill: "#E8273F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 18.5292V49.5308C53 52.1371 50.9017 54.25 48.3125 54.25H8.68747C6.0983 54.25 4 52.1371 4 49.5308V18.5292H53Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1204 28.3148H12.7906C11.7672 28.3148 10.9375 27.4751 10.9375 26.4394V25.406C10.9375 24.3702 11.7672 23.5306 12.7906 23.5306H14.1203C15.1438 23.5306 15.9735 24.3702 15.9735 25.406V26.4394C15.9735 27.4751 15.1438 28.3148 14.1204 28.3148Z",
    fill: "#245B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1452 28.3148H22.7823C21.7332 28.3148 20.8828 27.4751 20.8828 26.4394V25.406C20.8828 24.3702 21.7332 23.5306 22.7823 23.5306H24.1452C25.1943 23.5306 26.0447 24.3702 26.0447 25.406V26.4394C26.0447 27.4751 25.1943 28.3148 24.1452 28.3148Z",
    fill: "#245B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0915 28.3148H32.7286C31.6795 28.3148 30.8291 27.4751 30.8291 26.4394V25.406C30.8291 24.3702 31.6795 23.5306 32.7286 23.5306H34.0915C35.1406 23.5306 35.991 24.3702 35.991 25.406V26.4394C35.9909 27.4751 35.1406 28.3148 34.0915 28.3148Z",
    fill: "#245B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0842 28.3148H42.7545C41.731 28.3148 40.9014 27.4751 40.9014 26.4394V25.406C40.9014 24.3702 41.731 23.5306 42.7545 23.5306H44.0842C45.1077 23.5306 45.9373 24.3702 45.9373 25.406V26.4394C45.9373 27.4751 45.1076 28.3148 44.0842 28.3148Z",
    fill: "#245B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1204 36.75H12.7906C11.7672 36.75 10.9375 35.9104 10.9375 34.8746V33.8412C10.9375 32.8054 11.7672 31.9658 12.7906 31.9658H14.1203C15.1438 31.9658 15.9735 32.8054 15.9735 33.8412V34.8746C15.9735 35.9105 15.1438 36.75 14.1204 36.75Z",
    fill: "#245B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1452 36.75H22.7823C21.7332 36.75 20.8828 35.9104 20.8828 34.8746V33.8412C20.8828 32.8054 21.7332 31.9658 22.7823 31.9658H24.1452C25.1943 31.9658 26.0447 32.8054 26.0447 33.8412V34.8746C26.0447 35.9105 25.1943 36.75 24.1452 36.75Z",
    fill: "#245B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0915 36.75H32.7286C31.6795 36.75 30.8291 35.9104 30.8291 34.8746V33.8412C30.8291 32.8054 31.6795 31.9658 32.7286 31.9658H34.0915C35.1406 31.9658 35.991 32.8054 35.991 33.8412V34.8746C35.9909 35.9105 35.1406 36.75 34.0915 36.75Z",
    fill: "#F8485E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.0842 36.75H42.7545C41.731 36.75 40.9014 35.9104 40.9014 34.8746V33.8412C40.9014 32.8054 41.731 31.9658 42.7545 31.9658H44.0842C45.1077 31.9658 45.9373 32.8054 45.9373 33.8412V34.8746C45.9373 35.9105 45.1076 36.75 44.0842 36.75Z",
    fill: "#245B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1204 45.3111H12.7906C11.7672 45.3111 10.9375 44.4494 10.9375 43.3864V42.3258C10.9375 41.2628 11.7672 40.4011 12.7906 40.4011H14.1203C15.1438 40.4011 15.9735 41.2628 15.9735 42.3258V43.3864C15.9735 44.4494 15.1438 45.3111 14.1204 45.3111Z",
    fill: "#245B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1452 45.3111H22.7823C21.7332 45.3111 20.8828 44.4494 20.8828 43.3864V42.3258C20.8828 41.2628 21.7332 40.4011 22.7823 40.4011H24.1452C25.1943 40.4011 26.0447 41.2628 26.0447 42.3258V43.3864C26.0447 44.4494 25.1943 45.3111 24.1452 45.3111Z",
    fill: "#245B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0915 45.3111H32.7286C31.6795 45.3111 30.8291 44.4494 30.8291 43.3864V42.3258C30.8291 41.2628 31.6795 40.4011 32.7286 40.4011H34.0915C35.1406 40.4011 35.991 41.2628 35.991 42.3258V43.3864C35.9909 44.4494 35.1406 45.3111 34.0915 45.3111Z",
    fill: "#245B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14725 49.5312V18.5292H4V49.5308C4 52.1371 6.0983 54.25 8.68747 54.25H11.8347C9.24555 54.25 7.14725 52.1371 7.14725 49.5312Z",
    fill: "#D0CFD5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2357 1.75C12.9488 1.75 11.9062 2.80022 11.9062 4.09558V7.58311C11.9062 8.87847 12.9492 9.92869 14.2357 9.92869C15.5221 9.92869 16.5651 8.87847 16.5651 7.58311V4.09558C16.5651 2.80022 15.5221 1.75 14.2357 1.75Z",
    fill: "#245B62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.764 1.75C44.0504 1.75 45.0934 2.80022 45.0934 4.09558V7.58311C45.0934 8.87847 44.0504 9.92869 42.764 9.92869C41.4776 9.92869 40.4346 8.87847 40.4346 7.58311V4.09558C40.4346 2.80022 41.4776 1.75 42.764 1.75Z",
    fill: "#245B62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1dec2e095ed6c5bc288bb617e36de2c3.svg";
export { ForwardRef as ReactComponent };